/**
 * Structure teleport picker (T): a vanilla-style button list on its own GUI
 * stage. Replaces the picker the old DOM HUD carried.
 */

import { GuiStage, Label, McButton } from './kit';
import type { StructureHit } from '../worldgen/structures';

export class TeleportMenu {
  readonly stage: GuiStage;
  open = false;
  onClose: (() => void) | null = null;

  constructor(parent: HTMLElement, guiScale: () => number) {
    this.stage = new GuiStage(parent, 45);
    this.stage.hide();
    this.guiScale = guiScale;
  }
  private readonly guiScale: () => number;

  show(hits: StructureHit[], onPick: (hit: StructureHit) => void): void {
    const st = this.stage;
    st.setGuiScaleSetting(this.guiScale());
    st.show();
    const c = st.content;
    c.replaceChildren();
    const dim = document.createElement('div');
    dim.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;background:rgba(16,16,16,0.78);';
    c.appendChild(dim);
    const cx = Math.floor(st.width / 2);
    c.appendChild(new Label('Teleport to Structure', cx, 12, { align: 'center', color: '#ffffff' }).el);
    if (hits.length === 0) {
      c.appendChild(new Label('No structures nearby. Walk further and try again.', cx, 60, { align: 'center', color: '#aaaaaa' }).el);
    }
    const rows = Math.min(hits.length, 8);
    for (let i = 0; i < rows; i++) {
      const h = hits[i];
      const label = `${h.name}  ${Math.round(h.dist)}m`;
      const b = new McButton(label, cx - 100, 30 + i * 22, 200, 20, () => { this.hide(); onPick(h); });
      c.appendChild(b.el);
    }
    const done = new McButton('Cancel', cx - 100, 30 + rows * 22 + 12, 200, 20, () => { this.hide(); this.onClose?.(); });
    c.appendChild(done.el);
    this.open = true;
  }

  hide(): void {
    this.open = false;
    this.stage.hide();
    this.stage.content.replaceChildren();
  }
}
